export default __webpack_public_path__ + "static/media/loading_logo_color.e01ef0d5.gif";